<!--
  购物车
  lovi 2020-06-24
-->
<template>
  <div>
    <div
      class="shop-cart"
      :class="{ 'not-open': !storeInfo.is_business, 'no-goods': !quantity }"
    >
      <template v-if="storeInfo.is_business == 0">
        {{ $t("shopCart.noOpening") }}
      </template>
      <template v-else>
        <div class="cart">
          <van-icon
            v-if="quantity"
            @click="shopCartFlag = !shopCartFlag"
            name="cart"
            :badge="quantity"
          />
          <van-icon v-else name="cart" />
        </div>
        <div class="info">
          <div class="total-money">
            <template v-if="quantity == 0">
              {{ $t("shopCart.unpurchasedGoods") }}
            </template>
            <template v-else>
              {{ $t("life.total")
              }}<span class="money">{{ paymentAmount }}P</span
              ><span class="discount_money" v-if="Number(originalPrice) > 0"
                >{{ originalPrice }}P</span
              >
            </template>
          </div>
          <p>
            {{ $t("shopCart.additionalDeliveryFee")
            }}{{ storeInfo.delivery_fee }}P,{{ $t("life.packingFee")
            }}{{ storeInfo.packaging_fee }}P
          </p>
        </div>
        <van-button
          type="info"
          :disabled="quantity == 0 || shortAmount > 0"
          @click="submit"
        >
          <template v-if="quantity == 0">
            {{ storeInfo.starting_price }}P
            {{ $t("life.freeDelivery") }}
          </template>
          <template v-else-if="shortAmount > 0">
            {{ $t("shopCart.stillNeed") }}
            {{ shortAmount }}P
            {{ $t("life.freeDelivery") }}
          </template>
          <template v-else>
            {{ $t("shopCart.toSettlement") }}
          </template>
        </van-button>
      </template>
    </div>

    <van-popup
      v-model="shopCartFlag"
      class="popup-shopCart"
      overlay-class="overlay-shopCart"
      position="bottom"
    >
      <div class="title">
        <span>
          {{ $t("shopCart.shoppingCart") }}
          ({{ $t("shopCart.gong") }}{{ shopCartData.length }}
          {{ $t("shopCart.items") }})
        </span>
        <span @click="emptyShopCart">
          <van-icon name="delete" />
          {{ $t("shopCart.clearCart") }}
        </span>
      </div>
      <div v-if="Number(fullReduction)" class="full_reduction">
        <i>{{ $t("coupon.cashback") }}</i>
        <span class="text-red">
          {{ $t("coupon.reduced") }}
          {{ fullReduction }}P
        </span>
      </div>
      <div class="shop-list">
        <template v-for="(item, index) in shopCartData">
          <shop-list :key="index" :data="item" />
        </template>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ShopList from "@/components/life/shopList";
export default {
  props: ["activity"],
  components: {
    ShopList
  },
  data() {
    return {
      storeInfo: {}, // 店铺信息
      shopId: "",
      originalPrice: 0, // 原价
      sellingPrice: 0, // 售价
      quantity: 0, // 商品数量
      totalAmount: 0, // 统计金额(商品总金额 + 包装费 + 配送费)
      shortAmount: 0, //还差多少金额 起送费 - (商品总金额 + 包装费 + 配送费)
      fullReduction: 0, // 满减
      paymentAmount: 0, // 实际支付金额(商品总金额 + 包装费 + 配送费) - 满减
      originalPriceFlag: false, // 折扣商品
      shopCartFlag: false
    };
  },
  created() {
    this.storeInfo = JSON.parse(localStorage.getItem("storeInfo"));
    this.shopId = this.$route.query.shopId;
    this.dataProcessing(this.shopCartData);
  },
  mounted() {},
  computed: {
    ...mapGetters(["shopCartData"])
  },
  methods: {
    dataProcessing(arr) {
      // 购物车数据处理
      let vm = this;
      let originalPrice = 0; // 原价
      let originalPrice1 = 0;
      let sellingPrice = 0; // 售价
      let quantity = 0;
      let totalAmount = 0;
      let shortAmount = 0;
      let fullReduction = 0; // 已减金额
      let startingPrice = Number(vm.storeInfo.starting_price); // 起送费
      vm.originalPriceFlag = false;
      for (let i = 0; i < arr.length; i++) {
        let original_price = Number(arr[i].original_price);
        let selling_price = Number(arr[i].selling_price);
        let count = Number(arr[i].count);
        if (original_price) {
          // 有折扣商品
          vm.originalPriceFlag = true;
        }
        originalPrice1 +=
          count * (original_price ? original_price : selling_price);
        originalPrice += count * original_price;
        quantity += count;
        sellingPrice += count * selling_price;
      }
      // 满减商品
      if (vm.activity && vm.activity.length) {
        let activity = vm.activity.sort(this.arrSort("money"));
        console.log("activity", activity);
        if (!vm.originalPriceFlag) {
          for (let key of activity) {
            if (sellingPrice >= Number(key.money)) {
              fullReduction = Number(key.discount);
              break;
            }
          }
        }
      }
      // 总金额
      totalAmount =
        sellingPrice +
        Number(vm.storeInfo.delivery_fee) +
        Number(vm.storeInfo.packaging_fee);
      if (totalAmount < startingPrice) {
        // 还差多少起送
        shortAmount = startingPrice - totalAmount;
      } else {
        shortAmount = 0;
      }
      vm.originalPrice = vm.originalPriceFlag
        ? originalPrice1.toFixed(2)
        : originalPrice.toFixed(2);
      vm.sellingPrice = sellingPrice.toFixed(2);
      vm.quantity = quantity;
      vm.totalAmount = totalAmount.toFixed(2);
      vm.shortAmount = shortAmount.toFixed(2);
      vm.fullReduction = fullReduction.toFixed(2);
      vm.paymentAmount = (sellingPrice - fullReduction).toFixed(2);
    },
    arrSort(key, bol) {
      // 排序的数组的key值
      return function(a, b) {
        let value1 = a[key];
        let value2 = b[key];
        if (bol) {
          // 升序排列
          return value1 - value2;
        } else {
          // 降序排列
          return value2 - value1;
        }
      };
    },
    emptyShopCart() {
      // 清空购物车
      let vm = this;
      vm.$dialog
        .confirm({
          message: vm.$t("shopCart.sureClearCart")
        })
        .then(() => {
          console.log("confirm");
          vm.$store.dispatch("SET_SHOPCART_DATA", "delete");
        })
        .catch(() => {
          console.log("cancel");
        });
    },
    submit() {
      // 去结算
      let vm = this;
      let arr = [];
      for (let i = 0; i < vm.shopCartData.length; i++) {
        let obj = {};
        obj.product_id = vm.shopCartData[i].product_id;
        obj.count = vm.shopCartData[i].count;
        arr.push(obj);
      }
      let params = {};
      params.list = JSON.stringify(arr);
      params.shop_id = vm.shopId;
      vm.$post("/app/shoppingcat/checkoutCat", params, { loading: true }).then(
        res => {
          console.log("checkoutCat", res);
          vm.$router.push({
            path: "/submitOrder",
            name: "submitOrder",
            params: res
          });
        }
      );
    }
  },
  watch: {
    shopCartData: {
      handler: function(arr) {
        let vm = this;
        if (!arr.length) {
          vm.shopCartFlag = false;
        }
        console.log("shopCart.shopCartData");
        vm.dataProcessing(arr);
      },
      deep: true
    }
  }
  // beforeDestroy: {}
};
</script>

<style lang="less" scoped>
/deep/.overlay-shopCart {
  z-index: 301 !important;
  bottom: 50px;
}
/deep/.popup-shopCart {
  z-index: 302 !important;
  bottom: 50px;
  height: auto;
  border-radius: 8px 8px 0 0;
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    padding: 0 10px;
    font-size: 14px;
    line-height: 1;
    border-bottom: 1.1px solid #e4e4e4;
    span {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      /deep/.van-icon-delete {
        margin-right: 2px;
        font-size: 16px;
      }
    }
  }
  .full_reduction {
    padding: 10px 10px 0 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    line-height: 1;
    i {
      display: flex;
      align-items: center;
      margin-right: 8px;
      padding: 0 8px;
      height: 16px;
      font-size: 10px;
      color: #fff;
      background: #fd4553;
      border-radius: 8px;
    }
  }
  .shop-list {
    padding: 5px 0;
  }
}
.shop-cart {
  z-index: 310;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 50px;
  color: #fff;
  background: #3e3e3e;
  &.not-open {
    justify-content: center;
    font-size: 16px;
    color: #bababa;
  }
  &.no-goods {
    .cart {
      /deep/.van-icon-cart {
        color: #6c6c6c;
      }
    }
    .info {
      color: #bababa;
      .total-money {
        font-size: 16px;
      }
    }
  }
  .cart {
    margin-left: 10px;
    /deep/.van-icon-cart {
      font-size: 36px;
      color: #1a83ff;
      .van-info {
        border: 0;
        font-size: 10px;
        top: 5px;
        right: 5px;
      }
    }
  }
  .info {
    flex: 1;
    padding: 0 10px;
    color: #d3d3d3;
    .total-money {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .money {
        font-size: 18px;
        color: #fff;
      }
      .discount_money {
        margin-left: 5px;
        text-decoration: line-through;
      }
    }
    p {
      font-size: 10px;
    }
  }
  /deep/.van-button {
    padding: 0;
    width: 100px;
    height: 50px;
    line-height: 1.2;
    border-radius: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    &.van-button--disabled {
      font-size: 14px;
      color: #bababa;
      background: #6c6c6c;
    }
  }
}
</style>
